import { Checkbox } from "@mui/material";
import { green } from "@mui/material/colors";
import React from "react";
import { Controller } from "react-hook-form";

const CheckInput = ({ control, text, id }) => {
  return (
    <section className="md:my-1">
      <div className="flex items-center">
        <Controller
        fullWidth
          name={id}
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <Checkbox
              {...field}
              //   defaultChecked
              sx={{
                color: green[300],
                // marginTop: "-10px",
                "&.Mui-checked": {
                  color: green[300],
                },
                "& .MuiSvgIcon-root": { fontSize: 24 },
              }}
            />
          )}
        />

        <p className="text-sm text-grey/80">{text}</p>
      </div>
    </section>
  );
};

export default CheckInput;
